<template>
  <div class="left side-menu">
    <div class="sidebar-inner slimscrollleft">
      <div id="sidebar-menu">
        <ul>
          <li class="text-muted menu-title">Navigation</li>
          <li v-for="item in keystone.config.app.menu" :key="item.to">
            <router-link :to="item.to" class="waves-effect">
               <i :class="item.icon"></i>
              <span> {{ item.text }} </span>
            </router-link>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'main-left-menu'
  }
</script>



// WEBPACK FOOTER //
// MainLeftMenu.vue?2f2820fc